export interface CategoryItem {
  id: string;
  title: string;
  description: string;
  image: string;
  link: string;
  subcategories?: string[];
}

export const allCatalogCategories: CategoryItem[] = [
  {
    id: 'transformers',
    title: 'Силовые трансформаторы',
    description: 'Трансформаторы ТСЛ, ТСЗ и ТМГ для промышленных и гражданских объектов',
    image: '/images/transformers/Foto3.jpg',
    link: '/catalog/transformers',
    subcategories: [
      'ТСЛ (сухие литые)',
      'ТСЗ (сухие защищенные)',
      'ТМГ (масляные герметичные)'
    ]
  },
  {
    id: 'ktp',
    title: 'Трансформаторные подстанции',
    description: 'КТП, КТПН, КТПНУ и БКТП для распределения электроэнергии',
    image: '/images/transformers/ktpn.jpg',
    link: '/catalog/ktp',
    subcategories: [
      'КТП (комплектные)',
      'КТПН (наружной установки)',
      'КТПНУ (утепленные)',
      'БКТП (бетонные)'
    ]
  },
  {
    id: 'switchgear',
    title: 'Щитовое оборудование',
    description: 'Распределительные щиты, щиты учета, ВРУ, шкафы управления',
    image: '/images/transformers/04VRU.webp',
    link: '/catalog/switchgear',
    subcategories: [
      'Распределительные щиты (ЩР, ЩРН)',
      'Щиты учета (ЩУ, ЩУРН)',
      'ВРУ',
      'Шкафы управления (ШУ)',
      'Щиты автоматики (ЩА)',
      'НКУ'
    ]
  },
  {
    id: 'kso',
    title: 'Камеры КСО',
    description: 'Камеры сборные одностороннего обслуживания 6-10 кВ',
    image: '/images/transformers/kso.webp',
    link: '/catalog/kso',
    subcategories: [
      'КСО-366',
      'КСО-386',
      'КСО-393',
      'КСО-298'
    ]
  },
  {
    id: 'cable',
    title: 'Силовые кабели',
    description: 'Медные и алюминиевые кабели различных марок и сечений',
    image: '/images/transformers/kable.JPG',
    link: '/catalog/cable',
    subcategories: [
      'Медные (ВВГ, ВБбШв)',
      'Алюминиевые (АВВГ, АВБбШв)',
      'С изоляцией из СПЭ',
      'Контрольные кабели'
    ]
  },
  {
    id: 'turnkey',
    title: 'Комплектация под ключ',
    description: 'Комплексные решения для энергоснабжения объектов',
    image: '/images/transformers/reshenia.jpg',
    link: '/catalog/turnkey',
    subcategories: [
      'Электрооборудование',
      'Электроустановочные изделия',
      'Блочно-модульные здания'
    ]
  }
]; 